"use client";

import { showNpsFeatureFlag } from "@utils/default";
import { FC, ReactNode, createContext, useEffect, useState } from "react";

interface Props {
  children: ReactNode;
}
interface BannerContextProps {
  successMessage: string;
  setSuccessMessage: (message: string) => void;
  errorMessage: string;
  setErrorMessage: (message: string) => void;
}
export const BannerContext = createContext<BannerContextProps>({
  successMessage: "",
  setSuccessMessage: () => {},
  errorMessage: "",
  setErrorMessage: () => {},
});

const BannerContextProvider: FC<Props> = ({ children }) => {
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string>("");

  useEffect(() => {
    let successTimeout: NodeJS.Timeout;
    let errorTimeout: NodeJS.Timeout;

    if (successMessage) {
      successTimeout = setTimeout(() => setSuccessMessage(""), showNpsFeatureFlag ? 2 * 60 * 1000 : 5000);
    }
    if (errorMessage) {
      errorTimeout = setTimeout(() => setErrorMessage(""), 5000);
    }

    return () => {
      clearTimeout(successTimeout);
      clearTimeout(errorTimeout);
    };
  }, [successMessage, errorMessage]);

  return <BannerContext.Provider value={{ successMessage, setSuccessMessage, errorMessage, setErrorMessage }}>{children}</BannerContext.Provider>;
};
export default BannerContextProvider;
